import { render, staticRenderFns } from "./NgImageGallery.vue?vue&type=template&id=c584be3c&scoped=true"
import script from "./NgImageGallery.vue?vue&type=script&lang=js"
export * from "./NgImageGallery.vue?vue&type=script&lang=js"
import style0 from "./NgImageGallery.vue?vue&type=style&index=0&id=c584be3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c584be3c",
  null
  
)

export default component.exports